import { z } from 'zod'
import { CheckboxFieldSchema } from '#app/utils/zod-helpers.js'

const BaseUserProfileAiSchema = z.object({
	isDefault: z.boolean(),
})

export const UserProfileAiCreateSchema = BaseUserProfileAiSchema.extend({})

export const UserProfileAiEditIsDefaultSchema = z.object({
	id: z.string(),
	isDefault: CheckboxFieldSchema,
})
export type UserProfileAiEditIsDefaultSchema = z.infer<
	typeof UserProfileAiEditIsDefaultSchema
>
export type UserProfileAiEditIsDefaultInput = z.input<
	typeof UserProfileAiEditIsDefaultSchema
>
